import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import SearchIcon from '@mui/icons-material/Search';

import LookViewTypeSwitcher from "../../../../../../../look/lookNavigation/lookMain/lookViewTypeSwitcher";
import {
  SIDEBAR_NAVIGATION_BUTTONS,
  SIDEBAR_NAVIGATION_BUTTONS_LEVEL3
} from "../../../../../../constants";
import {
  setFeaturePicker,
  setSQFTActiveButton,
  setSQFTActiveLevel3Button,
  setSQFTMenuOpened
} from "../../../../../../../../actions/sqftMenuFunctions";
import { setLookActiveCategory } from "../../../../../../../../actions/lookFunctions";
import { showFilters } from "../../../../../../../../actions/actionFunctions";
import { setGroheFiltersSearchText } from "../../../../../../../../actions/groheFunctions";
import { getFeatureGroupName } from "../../../../../../../../misc/helpers";
import { getCurrentLayout } from "../../../../../../../appLayout";

const SQFTFeaturesHeader = (props) => {
  const {
    headerTitle,
    partId,
    intl,
    setSQFTActiveButton,
    setSQFTMenuOpened,
    activeLevel3Button,
    setSQFTActiveLevel3Button,
    setLookActiveCategory,
    showFilters,
    isFiltersOpened,
    setGroheFiltersSearchText,
    fabricatorData,
    setFeaturePicker,
    showSearch = true,
    showViewTypeSwitcher = true,
  } = props;

  useEffect(() => {
    return () => {
      setGroheFiltersSearchText("");
    };
  }, [setGroheFiltersSearchText]);

  const handleClose = () => {
    setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.move);
    setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.move);
    setFeaturePicker({ isOpen: false, partIds: [], shapeId: "", type: "" });
  };

  const handleSearchClick = (e) => {
    void e;
    if (activeLevel3Button === SIDEBAR_NAVIGATION_BUTTONS_LEVEL3.filters) {
      setSQFTActiveLevel3Button(null);
      setGroheFiltersSearchText("");
      showFilters(false);
    } else {
      setLookActiveCategory(partId); // set filters featureGroup
      showFilters(!isFiltersOpened);
      setSQFTActiveLevel3Button(SIDEBAR_NAVIGATION_BUTTONS_LEVEL3.filters);
    }
  };

  let featureGroupName = "";
  if (partId) {
    const layout = getCurrentLayout();
    const featureGroup = layout.getFeatureGroupByPartId(partId);
    featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);
  }

  return (
    <Fragment>
      <div className="side-level2__header">
        {showSearch && (
          <IconButton
            aria-label={intl.formatMessage({ id: "sqft.popup.slabmode.search" })}
            onClick={handleSearchClick}
            className="look-icon look-icon--gray look-icon--square look-icon--medium look-icon--white "
          >
            <SearchIcon />
          </IconButton>
        )}

        <div className="side-level2__header-title">
          {headerTitle ? headerTitle : featureGroupName}
        </div>

        <Fragment>
          {showViewTypeSwitcher && <LookViewTypeSwitcher />}
          <IconButton
            aria-label={intl.formatMessage({ id: "iconButton.close" })}
            className="look-icon look-icon--small2 look-icon--white"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Fragment>
      </div>
      {/*<div className="bv-item-header__buttons">*/}
      {/*  <input className="bv-item-header__search-input" type="text" placeholder="Search" value={searchInputValue} onChange={handleInputChange}/>*/}
      {/*  /!*<button className="materials-button materials-button--filters ">*!/*/}
      {/*  /!*  <span className="materials-button__text">Filters</span>*!/*/}
      {/*  /!*</button>*!/*/}
      {/*</div>*/}
    </Fragment>
  );
};

SQFTFeaturesHeader.propTypes = {
  featureTitleId: PropTypes.string,
  partId: PropTypes.string,
  showSearch: PropTypes.bool,
  showViewTypeSwitcher: PropTypes.bool,
};

const mapStateToProps = (store) => ({
  activeLevel3Button: store.sqftMenuState.activeLevel3Button,
  isFiltersOpened: store.filterState.showFilters,
  fabricatorData: store.fabricatorState,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setSQFTMenuOpened,
  setSQFTActiveLevel3Button,
  setLookActiveCategory,
  showFilters,
  setGroheFiltersSearchText,
  setFeaturePicker,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SQFTFeaturesHeader)
);
